import React from 'react';
import useSWR from 'swr';
import axios from 'axios';
import { Box, Paper, Typography } from '@mui/material';
import { apiHost } from '../../utils/apiHost';

// Bagian "Refund" di jendela Transaction Details. Setelah refund, barang yang direfund dikurangi dari transaksi
// (setelah refund penuh tabel Items kosong), jadi rinciannya ditampilkan di sini dari catatan refund.
const base = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};
const ambil = (url) => axios.get(url, { withCredentials: true }).then((r) => r.data);
const rupiah = (v) => `Rp ${Math.round(Number(v) || 0).toLocaleString('id-ID')}`;
const waktu = (iso) => (iso ? new Date(iso).toLocaleString('id-ID', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-');

const RefundDiDetail = ({ transaksiUuid }) => {
  const { data, error } = useSWR(transaksiUuid ? `${base()}/refund/transaksi/${transaksiUuid}` : null, ambil, { revalidateOnFocus: false });
  const riwayat = data?.data?.riwayat || [];
  if (error || riwayat.length === 0) return null;
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" gutterBottom>Refund</Typography>
      <Paper sx={{ p: 2, borderLeft: '4px solid #7b1fa2' }}>
        {riwayat.map((r, idx) => (
          <Box key={r.uuid} sx={{ mb: idx < riwayat.length - 1 ? 2 : 0 }}>
            <Typography variant="body2" fontWeight={700}>
              {waktu(r.createdAt)} · {rupiah(r.totalRefund)} · {r.alasanLabel}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              {[r.petugas && `oleh ${r.petugas}`, r.catatan].filter(Boolean).join(' · ')}
            </Typography>
            {(r.items || []).map((i, k) => (
              <Typography key={k} variant="body2" sx={{ ml: 1 }}>
                • {i.jumlah}× {i.namabarang} ({rupiah(i.nilai)}){i.kembalikanStok ? ' · kembali ke stok' : ''}
              </Typography>
            ))}
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default RefundDiDetail;
